import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RecipeCard from './RecipeCard';
import LanguageSelector from './LanguageSelector';
import RecipeFilters from './RecipeFilters';
import { getUITranslation } from './utils';

const RecipeList = ({ recipes, lang }) => {
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        cuisine: null,
        type: null,
        author: null
    });
    
    const handleLanguageChange = (newLang) => {
        navigate(`/recipe-book/${newLang}`);
    };

    const filteredRecipes = useMemo(() => {
        return recipes.filter(recipe => {
            // Filter by cuisine
            if (filters.cuisine && recipe.cuisine !== filters.cuisine) {
                return false;
            }
            
            // Filter by recipe type
            if (filters.type && recipe.type !== filters.type) {
                return false;
            }
            
            // Filter by author
            if (filters.author && recipe.author !== filters.author) {
                return false;
            }
            
            return true;
        });
    }, [recipes, filters]);
    
    return (
        <div>
            <div className="nav-controls">
                <Link className="back-btn" to="/">&larr; {getUITranslation('home', lang)}</Link>
                <LanguageSelector lang={lang} setLang={handleLanguageChange} />
            </div>
            
            <RecipeFilters filters={filters} setFilters={setFilters} lang={lang} />
            
            <div className="recipe-list">
                {filteredRecipes.map(recipe => (
                    <Link
                        key={recipe.id}
                        to={`/recipe-book/${lang}/${recipe.id}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <RecipeCard recipe={recipe} lang={lang} />
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default RecipeList; 